import { render, staticRenderFns } from "./StoryStatsPage.vue?vue&type=template&id=62dea1c5&scoped=true&"
import script from "./StoryStatsPage.vue?vue&type=script&lang=js&"
export * from "./StoryStatsPage.vue?vue&type=script&lang=js&"
import style0 from "./StoryStatsPage.vue?vue&type=style&index=0&id=62dea1c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dea1c5",
  null
  
)

export default component.exports